import React, { Component } from "react"
import { withStyles } from "@material-ui/core"

import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import * as constants from "../constants"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class bossToEmployeeCovarage extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)
      // console.log( this.props.bossToEmployeeCovarage)
            this.state = {
                  bossToEmployeeCovarageState: this.props.bossToEmployeeCovarage,
                  selectedThirdpartyCoverage: {
                        value: this.props.bossToEmployeeCovarage.boss_to_employee_coverage_id,
                        label: this.props.bossToEmployeeCovarage.boss_to_employee_coverage_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
            }
      }
      componentDidMount() {
            this.getoptionbossToEmployeeCoverage()
      }

      getoptionbossToEmployeeCoverage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].boss_to_employee_coverage_id, label: arr.data[k].boss_to_employee_coverage_name })
                              }
                              self.setState({ optionbossToEmployeeCoverage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/bossToEmployee`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedThirdpartyCoverage) => {
            var temparray = this.state.bossToEmployeeCovarageState
            temparray.bossToEmployee_price_covarage_bossToEmployee_covarage_id = selectedThirdpartyCoverage.value
            this.setState({ selectedThirdpartyCoverage: selectedThirdpartyCoverage, bossToEmployeeCovarageState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.bossToEmployeeCovarageState
            temparray.boss_to_employee_price_coverage_percent = event
            this.setState({ bossToEmployeeCovarageState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { bossToEmployeeCovarageState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_coverage")
            fd.append("boss_to_employee_price_coverage_id", bossToEmployeeCovarageState.boss_to_employee_price_coverage_id)
            fd.append("boss_to_employee_price_coverage_percent", bossToEmployeeCovarageState.boss_to_employee_price_coverage_percent)

            xhttp.open("POST", `${constants.BASE_URL}/bossToEmployee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { bossToEmployeeCovarageState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_coverage")
            fd.append("boss_to_employee_price_coverage_id", bossToEmployeeCovarageState.boss_to_employee_price_coverage_id)

            xhttp.open("POST", `${constants.BASE_URL}/bossToEmployee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionbossToEmployeeCoverage, snackMode, snackstr, showSnack, visible, selectedThirdpartyCoverage, bossToEmployeeCovarageState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={5}>
                                    <div>
                                          <label className="on"> پوشش بیمه</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"پوشش بیمه"}
                                                value={selectedThirdpartyCoverage}
                                                onChange={this.handleInstalmentMode}
                                                options={optionbossToEmployeeCoverage}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                          placeholder="درصد پوشش"
                                          type="percent"
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={bossToEmployeeCovarageState.boss_to_employee_price_coverage_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(bossToEmployeeCovarage)
